import { render, staticRenderFns } from "./MitAdminBuildingsSettingsPage.vue?vue&type=template&id=12c71336&scoped=true"
import script from "./MitAdminBuildingsSettingsPage.vue?vue&type=script&lang=js"
export * from "./MitAdminBuildingsSettingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c71336",
  null
  
)

export default component.exports